import cssVariables from 'tfs.css-variables'

export default {
  container: {
    position: 'relative',
    display: 'block',
    width: '100%',
    left: '0.3rem',
    alignItems: 'center',
  },
  tooltip: {
    display: 'none',
    position: 'absolute',
    bottom: '100%',
    left: '-1rem',
    marginBottom: '1rem',
    borderRadius: '0.5rem',
    fontWeight: 'bold',
    color: cssVariables.colorGrayA,
    width: 'auto',
    padding: '0.5rem',
    cursor: 'default',
    filter: 'drop-shadow(0 0.2rem 3px rgba(0,0,0,0.15))',
    backgroundColor: props =>
      props.inlineError
        ? cssVariables.colorInfoBackground
        : cssVariables.colorWhite,

    '&::after': {
      content: '""',
      width: 0,
      height: 0,
      borderLeft: '0.8rem solid transparent',
      borderRight: '0.8rem solid transparent',
      borderTop: props =>
        props.inlineError
          ? `0.9rem solid ${cssVariables.colorInfoBackground}`
          : `0.9rem solid ${cssVariables.colorWhite}`,
      position: 'absolute',
      left: '1rem',
      top: '100%',
    },
  },
  isActive: {
    display: 'block',
  },
  inlineError: {
    position: 'absolute',
    left: 'calc(100% - 1.5rem)',
    top: '0.8rem',
    zIndex: 5,
  },
  icon: {
    position: 'absolute',
    display: 'flex',
    height: '1rem',
    width: '1rem',
    left: '0.3rem',
    padding: '0.1rem',
    fontSize: '0.8rem',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100%',
    color: cssVariables.colorError,
  },
}
